import React, { useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useStore } from '@/context/StoreContext';
import { SignInForm } from '@/components/auth/AuthForms';
import { Seo } from '@/components/Seo';

export default function SignIn() {
  const { t, customer, customerLoading } = useStore();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') || '/account';

  useEffect(() => { if (!customerLoading && customer) navigate(next, { replace: true }); }, [customer, customerLoading]); // eslint-disable-line

  return (
    <div className="bg-nw-black">
      <Seo title={t.account.signIn} description={t.account.signInSub} path="/account/login" noindex />
      <div className="nw-container py-16 lg:py-24 flex justify-center">
        <div data-testid="signin-page" className="w-full max-w-md bg-nw-espresso border border-nw-gold/20 p-8 sm:p-12">
          <SignInForm onSuccess={() => navigate(next, { replace: true })} onSwitch={() => navigate(`/account/register${next !== '/account' ? `?next=${encodeURIComponent(next)}` : ''}`)} />
          <div className="mt-8 pt-6 border-t border-nw-gold/15 text-center">
            <Link to="/collections" className="text-[11px] tracking-luxe uppercase nw-link">{t.cart.continue}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
